import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import AnimationPreview from './AnimationPreview';
import AnimationControls from './AnimationControls';

const AnimationGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.ANIMATION]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.ANIMATION, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.ANIMATION, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Animation Generator</h2>
      <AnimationControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const AnimationPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.ANIMATION]);
  return <AnimationPreview config={config} />;
};

export default AnimationGenerator;

